import * as React from "react";
import { Field, Form, FormElement } from "@progress/kendo-react-form";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import ParticipantService from "../../../services/srv-participants/ParticipantService";
import { Button } from "reactstrap";
import LoadingPanel from "../../../components/sys-toolbox/LoadingPanel";
import useEnumData from "../../../utils/enums";
import {
  FormDatePicker,
  FormDateTimePicker,
  FormDropDownList,
  FormInput,
  FormTimePicker,
} from "../../../components/sys-form/FormComponents";
import {
  emailValidator,
  requiredValidator,
} from "../../../components/sys-form/FormValidators";
import alertify from "alertifyjs";

export const ParticipantForm = (props) => {
  const { t } = useTranslation();
  const { DATAYESNOTENTATIVE } = useEnumData();
  const [loading, setLoading] = useState(false);

  const handleSubmit = (dataItem) => {
    const { isValid, values } = dataItem;
    if (!isValid) {
      alertify.error("");
      return;
    }
    var katiliM_DURUMU = values.katiliM_DURUMU;
    var email = values.email;

    delete values.katiliM_DURUMU;
    var additionalInfo = JSON.stringify(values);
    var data = {
      eK_BILGILER: additionalInfo,
      etkinliK_KATILIMCI_ID: props.eventParticipant.etkinliK_KATILIMCI_ID,
      katiliM_DURUMU: katiliM_DURUMU,
      email: email,
    };
    setLoading(true);
    ParticipantService.updateEventParticipant(data).then(() => {
      setLoading(false);
    });
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-start",
        marginTop: "20px",
        padding: "0 15px",
        minHeight: "100vh",
      }}
    >
      {loading && <LoadingPanel />}
      <Form
        onSubmitClick={handleSubmit}
        render={(formRenderProps) => (
          <div
            style={{
              alignSelf: "center",
              width: "100%",
              maxWidth: "480px",
            }}
          >
            <FormElement
              style={{
                width: "100%",
                padding: "20px",
                boxSizing: "border-box",
              }}
            >
              <div
                style={{
                  width: "100%",
                  alignSelf: "center",
                  marginBottom: "20px",
                }}
              >
                <p
                  style={{
                    fontSize: "14px",
                    lineHeight: "1.4",
                    marginBottom: "15px",
                    textAlign: "center",
                  }}
                >
                  {t("first_enter_email")}
                </p>
                <Field
                  name="email"
                  id="email"
                  label={t("email")}
                  component={FormInput}
                  validator={(value) => emailValidator(value, t)}
                />
              </div>
              <hr style={{ margin: "20px 0" }} />

              <div style={{ marginBottom: "20px" }}>
                {props.data?.fields.map((field, index) => {
                  const fieldStyle = {
                    marginBottom: "15px",
                    width: "100%",
                  };

                  if (field.alaN_TIPI === "TEXT") {
                    return (
                      <div key={index} style={fieldStyle}>
                        <Field
                          name={field.alaN_KODU}
                          id={field.alaN_KODU}
                          label={field.alaN_ADI}
                          component={FormInput}
                          validator={(value) => requiredValidator(value, t)}
                        />
                      </div>
                    );
                  }
                  if (field.alaN_TIPI === "DROPDOWN") {
                    return (
                      <div key={index} style={fieldStyle}>
                        <Field
                          name={field.alaN_KODU}
                          id={field.alaN_KODU}
                          label={field.alaN_ADI}
                          component={FormDropDownList}
                          data={props.data.options.filter(
                            (a) => a.alaN_KODU === field.alaN_KODU
                          )}
                          textField="seceneK_ADI"
                          valueField="seceneK_KODU"
                          validator={(value) => requiredValidator(value, t)}
                          value={formRenderProps.valueGetter(field.alaN_KODU)}
                          onChange={(e) => {
                            formRenderProps.onChange(field.alaN_KODU, {
                              value: e.value.seceneK_KODU,
                            });
                          }}
                        />
                      </div>
                    );
                  }
                  if (field.alaN_TIPI === "DATETIME") {
                    return (
                      <div key={index} style={fieldStyle}>
                        <Field
                          name={field.alaN_KODU}
                          id={field.alaN_KODU}
                          label={field.alaN_ADI}
                          component={FormDateTimePicker}
                          validator={(value) => requiredValidator(value, t)}
                          value={formRenderProps.valueGetter(field.alaN_KODU)}
                        />
                      </div>
                    );
                  }
                  if (field.alaN_TIPI === "DATE") {
                    return (
                      <div key={index} style={fieldStyle}>
                        <Field
                          name={field.alaN_KODU}
                          id={field.alaN_KODU}
                          label={field.alaN_ADI}
                          component={FormDatePicker}
                          validator={(value) => requiredValidator(value, t)}
                          value={formRenderProps.valueGetter(field.alaN_KODU)}
                        />
                      </div>
                    );
                  }
                  if (field.alaN_TIPI === "TIME") {
                    return (
                      <div key={index} style={fieldStyle}>
                        <Field
                          name={field.alaN_KODU}
                          id={field.alaN_KODU}
                          label={field.alaN_ADI}
                          component={FormTimePicker}
                          validator={(value) => requiredValidator(value, t)}
                          value={formRenderProps.valueGetter(field.alaN_KODU)}
                        />
                      </div>
                    );
                  }
                  if (field.alaN_TIPI === "NUMBER") {
                    return (
                      <div key={index} style={fieldStyle}>
                        <Field
                          name={field.alaN_KODU}
                          id={field.alaN_KODU}
                          label={field.alaN_ADI}
                          type="number"
                          component={FormInput}
                          validator={(value) => requiredValidator(value, t)}
                        />
                      </div>
                    );
                  }
                  return null;
                })}
              </div>

              <hr style={{ margin: "20px 0" }} />

              <div style={{ marginBottom: "30px" }}>
                <Field
                  name="katiliM_DURUMU"
                  id="katiliM_DURUMU"
                  label={t("participation_status")}
                  component={FormDropDownList}
                  data={DATAYESNOTENTATIVE}
                  textField="text"
                  valueField="value"
                  validator={(value) => requiredValidator(value, t)}
                  value={formRenderProps.valueGetter("katiliM_DURUMU")}
                  onChange={(e) => {
                    formRenderProps.onChange("katiliM_DURUMU", {
                      value: e.value.value,
                    });
                  }}
                />
              </div>

              <hr style={{ margin: "20px 0" }} />

              <div
                style={{
                  textAlign: "center",
                  marginTop: "30px",
                }}
              >
                <Button
                  disabled={loading}
                  onClick={formRenderProps.onSubmit}
                  style={{
                    minWidth: "120px",
                    padding: "12px 24px",
                    fontSize: "16px",
                  }}
                >
                  {loading ? t("saving") : t("save")}
                </Button>
              </div>
            </FormElement>
          </div>
        )}
      />
    </div>
  );
};
